(function (Drupal) {
    Drupal.behaviors.slickInits = {
        attach: function (context, settings) {
            jQuery('.slider-single', context).each(function(index) {
                var $sliderSingle = jQuery(this);
                var $sliderNav = $sliderSingle.next('.slider-nav');

                $sliderSingle.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    prevArrow: '<button type="button" aria-label="Previous slide" class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#555555"><path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z"/></svg></button>',
                    nextArrow: '<button type="button" aria-label="Next slide" class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#555555"><path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z"/></svg></button>',
                    fade: false,
                    adaptiveHeight: true,
                    infinite: true,
                    dots: false,
                    responsive: [
                        { breakpoint: 1024, settings: { slidesToShow: 1, slidesToScroll: 1 }},
                        { breakpoint: 920, settings: { slidesToShow: 1, slidesToScroll: 1, dots: true, arrows: false }}
                    ],
                    asNavFor: $sliderNav,
                });

                $sliderNav.slick({
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    asNavFor: $sliderSingle,
                    dots: false,
                    focusOnSelect: true,
                    infinite: true,
                    arrows: false,
                    responsive: [
                        { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 }},
                        { breakpoint: 640, settings: { slidesToShow: 1, slidesToScroll: 1 }},
                        { breakpoint: 420, settings: { slidesToShow: 1, slidesToScroll: 1 }}
                    ]
                });
            });
            
            jQuery(document).ready(function() {
                jQuery('.slider-nav').each(function() {
                  var $sliderNav = jQuery(this);
                  var slideCount = $sliderNav.find('.slick-track .slick-slide').length;
                  if (slideCount <= 5) {
                    $sliderNav.find('.slick-track').addClass('few-slides');
                  }
                });
            });
        }
    };
})(Drupal);
